@let apiResponse = data.value();
<div class="flex flex-col h-full">
  <div>
    <h1>Pengeinstitutter</h1>
  </div>
  <p-tabs
    [(value)]="piService.activeTab"
    class="flex-1 border-1 overflow-hidden"
  >
    <p-tablist>
      <p-tab value="search"><i class="pi pi-search"></i> Søgning</p-tab>
      @if (apiResponse && apiResponse.data.length > 0) {
        <p-tab value="result"
        ><i class="pi pi-list"></i> Resultat
        </p-tab
        >
      }
      @if (piService.selectedPi()) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="search">
        <app-pi-search />
      </p-tabpanel>
      <p-tabpanel value="result">
        <app-pi-result />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-pi-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
